import styles from 'styles/modules/Tags.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
import { setSearch } from 'store/navigation-search';

const Tags = ({ data, disabled }) => {
    const { isAuthorized } = useSelector(authSelector);
    const dispatch = useDispatch();
    if (!data) return null;

    const handleOnClick = (item) => {
        if (data.onClick) {
            data.onClick(item);
        }
    };
    return data.activeTags.slice(0, data.limit).map((item, key) => {
        return (
            <div
                className={[
                    styles.tag,
                    isAuthorized ? styles.tagActive : '',
                ].join(' ')}
                key={`tag-${key}`}
            >
                <span
                    onClick={
                        disabled
                            ? undefined
                            : (e) => {
                                  dispatch(setSearch(item.name || item));
                                  window.scrollTo(0, 0);
                              }
                    }
                >
                    {item.name ? item.name : item}
                </span>
                {isAuthorized && (
                    <div
                        className={styles.remove}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOnClick(item);
                        }}
                    >
                        Remove
                    </div>
                )}
            </div>
        );
    });
};

export default Tags;
